// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"og_a bhh_a bhh_x","FilterForm__vgroup":"og_b bhh_st"};